"use strict";

import React from "react";
import PropTypes from "prop-types";
import Table from "../../controls/Table.jsx";
import * as Constants from "../../utilities/Constants";

const UserTable = props => {

    const filterS7 = !(props.selectedProducts[0] == Constants.ORGANIZATION_PRODUCT_VERIFORM && props.selectedProducts.length == 1);

    const itemsPerPage = 25;

    const selectRowProp = {
        mode: "radio",
        clickToSelect: true,
        onSelect: props.onSelect,
        hideSelectColumn: true
    };

    const dateFormatter = (cell, row) => {
        var options = {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric'
        };

        var date = "";
        if (row.lastLogin) {
            var bits = cell.split(/[-T:+Z]/g);
            var d = new Date(bits[0], bits[1] - 1, bits[2]);
            // eslint-disable-next-line no-useless-escape
            var secondBits = bits[5].split("\.");
            d.setHours(bits[3], bits[4], secondBits[0]);
            date = d.toLocaleString("en-US", options);
        }

        return <span>{date}</span>;
    };

    const userFormatter = (cell, row) => {
        return <a onClick={() => props.onSelect(row)}>{cell}</a>;
    };

    const emailFormatter = (cell, row) => {
        if (cell && cell.length > 25) {
            var emailToDisplay = cell.substring(0, 25);
            return <div title={cell}><a>{emailToDisplay}&hellip;</a></div>;
        }
        return <div><a onClick={() => props.onSelect(row)}>{cell}</a></div>;
    };

    const iconFormatter = (cell, row) => {
        var spanToShow1 = "";
        var spanToShow2 = "";
        if (row.isLocked) {
            spanToShow1 = <span style={{ marginRight:"0px", marginLeft:"5px" }} className="glyphicon glyphicon-lock"/>;
        }
        if (row.isPasswordExpired) {
            spanToShow2 = <div title="Password reset needed"><span style={{ marginRight:"0px", marginLeft:"5px" }} className="glyphicon glyphicon-warning-sign"/></div>;
        }
        return <div>{spanToShow1}{spanToShow2}</div>;
    };

    const inactiveRowFormatter = (row, index) => {
        return row.isActive ? "" : 'inactive';
    };

    const columns = [
        {
            dataAlign: "left",
            dataField: "",
            label: "",
            width: "10",
            dataSort: false,
            dataFormat: iconFormatter
        },
        {
            dataAlign: "left",
            dataField: "userName",
            label: "Name",
            width: "250",
            dataSort: true,
            columnClassName: "userColumnClass",
            dataFormat: userFormatter
        },
        {
            dataAlign: "left",
            dataField: "email",
            label: "Email",
            width: "200",
            dataSort: true,
            columnClassName: "emailColumnClass",
            dataFormat: emailFormatter
        },
        {
            dataAlign: "left",
            dataField: "site",
            label: "Site ID",
            width: "80",
            dataSort: true
        },
        {
            dataAlign: "left",
            dataField: "login",
            isKey: true,
            label: "User ID",
            width: "80",
            dataSort: true
        },
        {
            dataAlign: "left",
            dataField: "userRolesString",
            label: "Role",
            width: "120",
            dataSort: true
        },
        {
            dataAlign: "left",
            dataField: "team",
            label: "Team",
            width: "140",
            dataSort: true,
            hidden: !filterS7
        },
        {
            dataAlign: "left",
            dataField: "userProductsString",
            label: "Product",
            width: "85",
            dataSort: true
        },
        {
            dataAlign: "left",
            dataField: "lastLogin",
            label: "Last Login",
            width: "120",
            dataSort: true,
            dataFormat: dateFormatter
        },
        {
            dataAlign: "left",
            dataField: "isActive",
            label: "",
            width: "0",
            hidden: true
        },
        {
            dataAlign: "left",
            dataField: "isLocked",
            label: "",
            width: "0",
            hidden: true
        },
        {
            dataAlign: "left",
            dataField: "isPasswordExpired",
            label: "",
            width: "0",
            hidden: true
        },
        // Empty column to prevent column stretching
        {
            dataAlign: "left",
            dataField: "",
            label: "",
            width: "0"
        }
    ];

    return (
        <div id="UsersTable">
            <Table
                data={props.users}
                selectRow={selectRowProp}
                search={false}
                columns={columns}
                options={{ sizePerPage: itemsPerPage }}
                bordered={false}
                pagination={true}
                striped={false}
                trClassName={inactiveRowFormatter}
            />
        </div>
    );
};

UserTable.propTypes = {
    users: PropTypes.arrayOf(PropTypes.shape({
        userName: PropTypes.string.isRequired,
        email: PropTypes.string,
        siteId: PropTypes.number,
        userId: PropTypes.number,
        role: PropTypes.string,
        selectedProducts: PropTypes.string
    })).isRequired
};

export default UserTable;
